class SliderBa extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initAddToCart();

    const buttons = this.querySelectorAll(".button");

    const cards = this.querySelectorAll(".card");

    cards.forEach((card) => {
      const textContent = card.querySelector(".paragraph-card");
      if (textContent && textContent.scrollHeight <= textContent.clientHeight) {
        card.querySelector(".button").classList.add("hidden");
      }
    });

    document.addEventListener('DOMContentLoaded', () => {
      const cardTexts = document.querySelectorAll('.card-text');
      cardTexts.forEach(card => {
        if (card.querySelector('.paragraph-card')) {
          const paragraph = card.querySelector('.paragraph-card');
          if (paragraph.scrollHeight > paragraph.clientHeight) {
            const button = document.createElement('button');
            button.classList.add('button', 'button--secondary', 'button--small');
            button.textContent = "Lire plus";
            button.setAttribute('aria-label', "Lire plus");
            button.setAttribute('aria-expanded', "false");
            card.appendChild(button);
          } else {
            const existingButton = card.querySelector('.button');
            if (existingButton) {
              existingButton.remove();
            }
          }
        }
      });
    });

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const card = button.closest(".card");
        if (!card) return;

        const paragraph = card.querySelector(".paragraph-card");
        if (paragraph) {
          paragraph.classList.toggle("paragraph-card--open");
          paragraph.classList.toggle("paragraph-card--no-bg");

          if (paragraph.classList.contains("paragraph-card--open")) {
            button.textContent = "Réduire";
          } else {
            button.textContent = "Lire plus";
          }
        }
      });
    });

    const toggleButton = this.querySelector("#toggleCards");
    const cardsWrapper = this.querySelector(".cards-wrapper");

    if (cardsWrapper.querySelectorAll(".card.hidden").length === 0) {
      toggleButton.classList.add("hidden");
    }

    if (toggleButton && cardsWrapper) {
      cardsWrapper.classList.add("collapsed");

      toggleButton.addEventListener("click", () => {
        cardsWrapper.classList.toggle("collapsed");
        const cards = cardsWrapper.querySelectorAll(".card");
        cards.forEach((card, index) => {
          if (index > 8) {
            card.classList.toggle("hidden");
          }
        });
        if (cardsWrapper.classList.contains("collapsed")) {
          cardsWrapper.scrollIntoView({ behavior: "smooth" });
        }

        toggleButton.textContent = cardsWrapper.classList.contains("collapsed")
          ? "Voir plus"
          : "Voir moins";
      });
    }
  }

  initAddToCart() {
    const addToCartButtons = document.querySelectorAll(
      ".buy-button-card, .buy-button"
    );
    addToCartButtons.forEach((button) => {
      button.addEventListener(
        "click",
        function (event) {
          const data = {
            items: [],
          };
          data.items.push({
            id: parseInt(button.dataset.variant),
            quantity: 1,
          });

          this.addToCart(data);
        }.bind(this)
      );
    });
  }

  async addToCart(data) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then(function (response) {
      document
        .querySelector("side-cart")
        .dispatchEvent(new Event("dispatch:cart-drawer:refresh"));

      setTimeout(() => {
        document.querySelector("side-cart").openCart();
      }, 300);

      return response.json();
    });
  }
}

customElements.define("slider-ba", SliderBa);
